module.exports = __webpack_public_path__ + "static/media/testimonial-4.635ba0b2.png";